module.exports = __webpack_public_path__ + "static/media/existing_merchant_served.146cfc90.svg";